let language = {
    INTEGRATION_WITH_API_MAIN_TITLE: "API 集成",
    PARTNER_REGISTRATION_TITLE: "合作伙伴注册",
    PARTNER_REGISTRATION_TEXT: "成为 {{appName}} WhiteLabel 平台的合作伙伴",
    REGISTRATION_TITLE: "1. 注册",
    REGISTRATION_STEP_1: "(1) 进入 {{appName}} WhiteLabel 平台的注册页面，并按照指南进行操作。",
    ACTIVATION_TITLE: "2. 激活",
    ACTIVATION_STEP_1: "(1) 注册后，您的邮箱将收到一封验证邮件，用于激活您的账户。",
    ACTIVATION_STEP_2: "(2) 打开邮箱中的验证邮件，并点击验证链接进行激活。",
    ACTIVATION_STEP_3: "(3) 要接收新的验证邮件，您可以登录 {{appName}} WhiteLabel 平台并点击仪表板。",
    LOGIN_TITLE: "3. 登录",
    LOGIN_STEP_1: "(1) 成功注册后，您可以登录 {{appName}} WhiteLabel 平台。",
    STORE_CREATION_TITLE: "店铺创建",
    STORE_CREATION_SUBTITLE_1: "1. 店铺创建",
    STORE_CREATION_STEP_1: "(1) 转到 \"仪表板\" 并选择 \"店铺\"。点击 \"新建\" 按钮以创建您的 {{appName}} WhiteLabel 店铺。",
    STORE_CREATION_STEP_2: "(2) 导航到创建新店铺页面，选择 \"API 集成\"。然后点击 \"创建店铺\" 以创建您的店铺。",
    STORE_CREATION_STEP_3: "(3) 创建后，您可以管理您的店铺。",
    
    PRODUCT_SELECTION_SUBTITLE_1: "2. 产品选择",
    PRODUCT_SELECTION_STEP_1: "(1) 转到 \"仪表板\" 并选择 \"店铺产品\"。点击 \"添加\" 按钮以创建您的 {{appName}} WhiteLabel 店铺产品。",
    PRODUCT_SELECTION_STEP_2: "(2) 点击 \"添加\" 按钮后，您将被重定向到产品目录页面。选择您要添加的店铺产品并点击进入产品详情页面。",
    PRODUCT_SELECTION_STEP_3: "(3) 在产品详情页面点击 \"添加到店铺\" 按钮以将产品添加到店铺。",
    PRODUCT_SELECTION_STEP_4: "(4) 点击 \"无设计 SKU\" 开始编辑您要添加的店铺产品。",
    PRODUCT_SELECTION_STEP_5: "(5) 创建后，您可以管理您的店铺产品。",
    STORE_ORDER_INTEGRATION_TITLE: "店铺订单集成",
    STORE_ORDER_INTEGRATION_SUBTITLE_1: "1. 获取 {{appName}} WhiteLabel 店铺产品 ID",
    STORE_ORDER_INTEGRATION_STEP_1: "前往 {{appName}} WhiteLabel 的 \"仪表板\"，点击 \"合作伙伴档案\" 查看店铺的产品列表信息，并获取 {{appName}} WhiteLabel 的店铺产品 ID。",
    STORE_ORDER_INTEGRATION_SUBTITLE_2: "2. 获取您的订单定制数据",
    STORE_ORDER_INTEGRATION_STEP_2: "根据您的订单详情获取相应的定制信息。",
    STORE_ORDER_INTEGRATION_SUBTITLE_3: "3. 使用简化定制订单 API 创建订单",
    STORE_ORDER_INTEGRATION_STEP_3: "根据上述获取的 {{appName}} WhiteLabel 店铺产品 ID 和您的订单定制数据，调用 {{appName}} WhiteLabel 店铺零售订单简化定制 API 生成带有基本定制的零售订单。",
    INTEGRATION_GUIDELINES_TITLE: "指南",
    INTEGRATION_GETTING_STARTED_TITLE: "入门",
    INTEGRATION_ABOUT_API_SERVICE_TITLE: "关于 API 服务",
    INTEGRATION_DOCUMENTATION_TITLE: "文档",
    INTEGRATION_OVERVIEW_TITLE: "概述",
    INTEGRATION_NAME_API_TITLE: "{{appName}} API",
    INTEGRATION_PARTNER_REGISTRATION: "合作伙伴注册",
    INTEGRATION_STORE_CREATION: "店铺创建",
    INTEGRATION_SIMPLE_STORE_ORDER: "简单店铺订单集成",
    INTEGRATION_CONTENTS: "目录",
};

export { language };
